/**
 * Example:
 * VTips.WM.getModalManager().pushWindow(
 * 	VTips.WM.Window.createWindowWithContent('register-success', 300, 200, success)
 * );
 *
 * var modalBox = createVTipsModalBox(saveTitle, modalBody);
 * var wndw = VTips.WM.Window.createWindowWithContent('saving-suitcase', 350, 300, modalBox);
 * VTips.WM.getModalManager().pushWindow( wndw, {allowClickOutside:true} );
 */

var VTips = {};
VTips.Size = function(width, height) {
	this.width = width;
	this.height = height;
};
VTips.WM = { // Window manager
	activeModal:null
};
/**
 * @param string id HTML ID
 * @param VTips.Size size
 * @constructor
 */
VTips.WM.Window = function(id, size) {
	this.id = id;
	this.size = size;
	this.content = null;
}

/**
 * Display the window
 *
 * @param {} opts
 */
VTips.WM.Window.prototype.display = function(opts) {
    var width = this.size.width;
    var height = this.size.height;

    if (typeof(opts.animate) == 'undefined') opts.animate = false;

    animateSpeed = null;
    if (opts.animate) {
        animateSpeed = 'fast';
    }

    var css_obj = {
        zIndex:opts.zIndex
    };

    if (width) {
        css_obj.width = width + 'px';
        css_obj.marginLeft = -(width/2) + 'px'
    }
    if (height) {
        css_obj.height = height + 'px';
        css_obj.marginTop = -(height/2) + 'px';
    }

    if ($('#'+this.id).length > 0) { // Already exists
        // prepare window object
        var window_obj = $('#' + this.id);
        if (!window_obj.hasClass('window-view')) window_obj.addClass('window-view');

        window_obj.css(css_obj);
        if (this.content) {
            window_obj.html(this.content);
        }
        $('body').append(window_obj);
        window_obj.show(animateSpeed); //
    } else { // Create from scratch
        /*
        window_obj = $('<div></div>').
                hide().
                attr('id', this.id).
                addClass('window-view').
                css(css_obj).
                css('width', css_obj.width).
                html(this.content).
                show(animateSpeed);
        */
        window_obj = $('<div></div>').
        css('visibility', 'hidden').
        attr('id', this.id).
        addClass('window-view').
        html(this.content).
        hide();
        $('body').append(window_obj);
        window_obj.css('visibility', 'visible');
        window_obj.css(css_obj);
        window_obj.show(animateSpeed);
    }
}
/**
 * Factory to create window using content
 *
 * @param {string} id HTML ID
 * @param {int} width
 * @param {int} height
 * @param {string} content The content to inject into the window
 * @returns {VTips.WM.Window}
 */
VTips.WM.Window.createWindowWithContent = function(id, width, height, content) {
    var window_size = new VTips.Size(width, height);
    var the_window = new VTips.WM.Window(id, window_size);
    the_window.content = content;
    return the_window;
}
/**
 * Factory to create window using existing HTML container
 * @param {string} id HTML ID
 * @param {int} width
 * @param {int} height
 * @returns {VTips.WM.Window}
 */
VTips.WM.Window.makeContainerAWindow = function(id, width, height) {
    var window_size = new VTips.Size(width, height);
    var the_window = new VTips.WM.Window(id, window_size);
    the_window.content = $('#' + id).html();
    return the_window;
}
/**
 * Represents modal window that can be pushed onto a stack
 *
 * @param {VTips.WM.Window} vtips_wm_window
 * @param {} opts
 * @constructor
 */
VTips.WM.ModalWindow = function(vtips_wm_window, opts) { // allow escape close, whether ESC or clicking outside
	this.window = vtips_wm_window;
	//this.allowClickOutside = allow_click_outside;
	this.opts = opts;
}
/**
 * Get the window object
 *
 * @returns VTips.WM.Window
 */
VTips.WM.ModalWindow.prototype.getWindow = function() {
	return this.window;
}
/**
 * Whether clicking outside the window closes it
 *
 * @returns {boolean}
 */
VTips.WM.ModalWindow.prototype.allowClickOutside = function() {
	return this.opts.allowClickOutside;
}
/**
 * Manages a modal window stack
 *
 * @constructor
 */
VTips.WM.Modal = function() {
	this.windowStack = [];
	this.overlayObj = null;
}
/**
 * Close the modal
 */
VTips.WM.Modal.prototype.close = function() {
	this.popAllWindows();
	jQuery(".modal-overlay").remove();
	VTips.WM.activeModal = null;
}
/**
 * Get the index of the window currently being displayed
 *
 * @returns {number}
 */
VTips.WM.Modal.prototype.getCurrentWindowIndex = function() { return this.windowStack.length-1; }
/**
 * Removes a window at a given index
 *
 * @param int index
 */
VTips.WM.Modal.prototype.removeWindowAtIndex = function(index) {
	if (index > 0 && index  < this.windowStack.length) {
		this.windowStack.splice(index, 1);
	}
}
/**
 * Remove all windows from the stack
 *
 * @returns {boolean}
 */
VTips.WM.Modal.prototype.popAllWindows = function() {
	if (this.windowStack.length > 0) {
		for(i=this.windowStack.length-1; i >= 0; i--) {
			jQuery('#' + this.windowStack[i].getWindow().id).hide();
		}
		this.windowStack = [];
	}
	return true;
}
/**
 * Get the object that represents the overlay
 * @returns {jQuery|HTMLElement}
 */
VTips.WM.Modal.prototype.getOverlayObj = function() {
	return this.overlayObj;
}
/**
 * Add the overlay to the screen
 *
 * @param {bool} allow_click_outside
 * @returns {*|jQuery|HTMLElement}
 */
VTips.WM.Modal.prototype.addOverlay = function(allow_click_outside) {
	if ($('.modal-overlay').length == 0) {
		var overlay = $('<div></div>');
		overlay.addClass('modal-overlay');
		if (allow_click_outside) {
			overlay.click(function() {
					VTips.WM.activeModal.close();
				});
		}
		this.overlayObj = overlay;
		$('body').append(overlay);
		return overlay;
	}
}
/**
 * Push a modal window onto the stack
 *
 * @param {VTips.WM.Window} the_window
 * @param {} append_options
 * @param {bool} animate
 */
VTips.WM.Modal.prototype.pushWindow = function(the_window, append_options, animate) {
	var opts = {
		allowClickOutside : false,
		addOverlay : true
	}
	jQuery.extend(opts, append_options);
	
	if (typeof(opts.allowClickOutside) == 'undefined') opts.allowClickOutside = false;
	if (typeof(opts.addOverlay) == 'undefined') opts.addOverlay = true;
	if (typeof(animate) == 'undefined') animate = true;
	
	var displayOptions = {
		animate : animate
	};

	var modal_window = new VTips.WM.ModalWindow(the_window, opts)
	if (opts.addOverlay) this.addOverlay(opts.allowClickOutside);

	if (this.windowStack.length > 0) {
		$('#' + this.windowStack[this.windowStack.length-1].getWindow().id).hide(); 
	}
	this.windowStack.push(modal_window);
	
	if (VTips.WM.activeModal) {
		displayOptions.zIndex = 101 + this.windowStack.length;
		modal_window.getWindow().display(displayOptions);
	}
}
/**
 * Push multiple windows onto the stack
 *
 * @param {[VTips.WM.Window]} the_windows
 * @param {} append_options
 */
VTips.WM.Modal.prototype.pushWindows = function(the_windows, append_options) {
	if (typeof(the_windows) == 'object') {
		for(i=0; i < the_windows.length; i++) {
			var animate = (i == the_windows.length-1);
			this.pushWindow(the_windows[i], append_options, animate);
		}
	}
}
/**
 * Remove single window from the stack
 *
 * @param {bool} close_overlay
 */
VTips.WM.Modal.prototype.popWindow = function(close_overlay) {
	var length = this.windowStack.length;
	if (length > 0) {
		$('#' + this.windowStack[length-1].getWindow().id).hide('fast');
		
		this.windowStack.pop();
		length--;
		
		if (length > 0) {
			$('#' + this.windowStack[length-1].getWindow().id).show();
		} else {
			if (typeof(close_overlay) == 'undefined' || (typeof(close_overlay) != 'undefined' && close_overlay))
				this.close(); // Close modal view
		}
	}

}
/**
 * Singletone to retrieve active modal manager
 * @returns {null}
 */
VTips.WM.getModalManager = function() {
	if (!VTips.WM.activeModal) {
		VTips.WM.activeModal = new VTips.WM.Modal();
	}
	return VTips.WM.activeModal;
}